// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2VtMX","rootSmall":"AddTileButton_rootSmall__3zrvI"};